import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { TrashView } from "@/features/trash/components/trash-view";

// F4-A: trash (restore-only; purging is the server job's).
export const trashRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/trash",
  component: TrashView,
});
